import React from "react";
import NProgress from "nprogress";
import Headers from "../../../components/Headers";
import EditShop from "../components/EditShop";
import { Button, Table, Divider, Modal, message } from "antd";
import { fetchShopList, fetchDeleteShop } from "../../../api/shop";
const { Column } = Table;

const BreadCrumbData = [
  { path: "/page/business/business", name: "商户" },
  { path: "/page/business/business", name: "商户店铺" },
];
class ViewShop extends React.Component {
  state = {
    list: [],
    visible: false,
    isadd: true,
    shopInfo: {},
    fileList: [],
    previewVisible: false,
    previewImg: "",
    companyId: this.props.match.params.id,
  };
  handleCancel = () => {
    this.setState({
      visible: false,
      shopInfo: {},
      fileList: [],
    });
  };
  addShop = () => {
    this.setState({
      isadd: true,
      visible: true,
    });
  };
  EditShop = (record) => {
    console.log(record);
    this.setState({
      shopInfo: record,
      isadd: false,
      visible: true,

      fileList: record.logo
        ? [
            {
              url: "http://qiniu-retail.ieou.com/" + record.logo,
              uid: 0,
              thumbUrl: "http://qiniu-retail.ieou.com/" + record.logo,
              status: "done",
              response: {
                url: "http://qiniu-retail.ieou.com/" + record.logo,
              },
            },
          ]
        : [],
    });
  };
  //删除图片
  deleteShop = (record) => {
    Modal.confirm({
      title: "删除店铺",
      content: "确认删除此店铺？",
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        fetchDeleteShop(record.id).then((res) => {
          console.log(res);
          if (res.success) {
            this.getList();
            message.success("操作成功");
          }
        });
      },
    });
  };
  //图片预览关闭
  handlePreviewClose = () => {
    this.setState({
      previewVisible: false,
    });
  };
  //图片预览
  handlePreviewOpen = (value) => {
    this.setState({
      previewVisible: true,
      previewImg: value,
    });
  };
  componentDidMount() {
    this.getList();
  }
  getList = () => {
    fetchShopList(this.state.companyId).then((res) => {
      if (res.success) {
        this.setState({
          list: res.data,
        });
      }
    });
  };
  handleChange = ({ fileList }) => {
    console.log(fileList);
    this.setState({ fileList });
  };
  render() {
    const {
      list,
      visible,
      isadd,
      fileList,
      previewVisible,
      previewImg,
      shopInfo,
      companyId,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="salesData">
          <Button onClick={() => this.props.history.go(-1)}>返回</Button>
          <Button
            type="primary"
            disabled={list.length >= 1}
            onClick={this.addShop}
          >
            添加店铺
          </Button>
        </div>
        <div className="content">
          <Table rowKey="id" dataSource={list} pagination={false}>
            <Column title="店铺名称" dataIndex="name" key="name" />
            <Column
              title="店铺logo"
              dataIndex="logo"
              key="logo"
              render={(value) =>
                value ? (
                  <img
                    onClick={() => this.handlePreviewOpen(value)}
                    style={{ width: 40, height: 40 }}
                    src={"https://qiniu-retail.ieou.com/" + value}
                  ></img>
                ) : null
              }
            />
            <Column title="店铺编号" dataIndex="shopId" key="shopId" />
            <Column
              title="店铺地址"
              width="30%"
              dataIndex="address"
              key="address"
            />
            <Column
              title="操作"
              render={(value, record) => (
                <React.Fragment>
                  <a onClick={() => this.EditShop(record)}>编辑店铺</a>
                  <Divider type="vertical" />

                  <a onClick={() => this.deleteShop(record)}> 删除</a>
                </React.Fragment>
              )}
            />
          </Table>
        </div>
        <EditShop
          visible={visible}
          isadd={isadd}
          handleChange={this.handleChange}
          handleCancel={this.handleCancel}
          fileList={fileList}
          shopInfo={shopInfo}
          companyId={companyId}
          getList={this.getList}
        ></EditShop>
        <Modal
          title="图片预览"
          visible={previewVisible}
          onCancel={this.handlePreviewClose}
          footer={false}
          width="372px"
        >
          <img
            style={{ width: 324, height: 324 }}
            src={"https://qiniu-retail.ieou.com/" + previewImg}
          ></img>
        </Modal>
      </div>
    );
  }
}
export default ViewShop;
